import { render, staticRenderFns } from "./en-sentencePage.vue?vue&type=template&id=6b2e6e9e&scoped=true&"
import script from "./en-sentencePage.vue?vue&type=script&lang=js&"
export * from "./en-sentencePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e6e9e",
  null
  
)

export default component.exports